<template>
  <div class="frill-widget" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { frill, CancelablePromise, FrillWidget } from '@frillco/script'
import { FRILL_SCRIPT_KEY, FRILL_WIDGET_KEY } from '@/plugins/frill'

/*
  Loads the announcements widget for the header (the Frill container is set up once, in plugins/frill.ts). Frill opens
  it from the launcher set in the widget's settings: the megaphone, by its marker--app-header--frill-announcements-btn
  class.
*/
export default defineComponent({
  name: 'FrillWidget',

  data() {
    return {
      widget: null as CancelablePromise<FrillWidget> | null,
    }
  },
  mounted() {
    if (FRILL_SCRIPT_KEY && !this.$screen.isMobile(this.$mq)) {
      this.widget = frill('widget', { key: FRILL_WIDGET_KEY })
      this.widget.catch(error => console.error('Frill widget failed to load', error))
    }
  },
  beforeUnmount() {
    // Also cancels a widget that hasn't finished loading
    this.widget?.destroy()
    this.widget = null
  },
})
</script>
